export default __webpack_public_path__ + "static/media/logo-DTM-e1627056405195.baa31e8a.png";